import { c as _c } from "react/compiler-runtime";
import { CircleQuestionMark } from 'lucide-react';
const champStyleMap: Record<string, {
  backgroundSize: string;
  backgroundPosition: string;
}> = {
  Blitzcrank: {
    backgroundSize: '500px',
    backgroundPosition: '-230px -10px'
  },
  Ahri: {
    backgroundSize: '500px',
    backgroundPosition: '-175px -40px'
  },
  Braum: {
    backgroundSize: '460px',
    backgroundPosition: '-255px -64px'
  },
  Darius: {
    backgroundSize: '540px',
    backgroundPosition: '-365px -75px'
  },
  Ekko: {
    backgroundSize: '500px',
    backgroundPosition: '-220px -75px'
  },
  Illaoi: {
    backgroundSize: '500px',
    backgroundPosition: '-230px -105px'
  },
  Jinx: {
    backgroundSize: '500px',
    backgroundPosition: '-155px -105px'
  },
  Vi: {
    backgroundSize: '500px',
    backgroundPosition: '-205px -36px'
  },
  Yasuo: {
    backgroundSize: '540px',
    backgroundPosition: '-270px -80px'
  },
  Teemo: {
    backgroundSize: '180px',
    backgroundPosition: '-60px -35px'
  },
  Warwick: {
    backgroundSize: '180px',
    backgroundPosition: '-40px -50px'
  },
  Caitlyn: {
    backgroundSize: '250px',
    backgroundPosition: '-70px -10px'
  }
};
export const ChampIcon = t0 => {
  const $ = _c(21);
  const {
    championName,
    size: t1
  } = t0;
  const size = t1 === undefined ? 96 : t1;
  if (!champStyleMap[championName]) {
    const t2 = `${size}px`;
    const t3 = `${size}px`;
    let t4;
    if ($[0] !== t2 || $[1] !== t3) {
      t4 = {
        width: t2,
        height: t3,
        border: "1px solid rgba(255, 255, 255, 0.2)",
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        backgroundRepeat: "no-repeat",
        margin: "auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 0.5
      };
      $[0] = t2;
      $[1] = t3;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <CircleQuestionMark />;
      $[3] = t5;
    } else {
      t5 = $[3];
    }
    let t6;
    if ($[4] !== t4) {
      t6 = <div style={t4}>{t5}</div>;
      $[4] = t4;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    return t6;
  }
  const scale = size / 96;
  const style = champStyleMap[championName];
  let scaledBgSize;
  let t2;
  if ($[6] !== scale || $[7] !== style.backgroundPosition || $[8] !== style.backgroundSize) {
    const bgSizeParts = style.backgroundSize.split(" ");
    const bgPosParts = style.backgroundPosition.split(" ");
    let t3;
    if ($[11] !== scale) {
      t3 = part => part.endsWith("px") ? `${parseFloat(part) * scale}px` : part;
      $[11] = scale;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    scaledBgSize = bgSizeParts.map(t3).join(" ");
    let t4;
    if ($[13] !== scale) {
      t4 = part_0 => part_0.endsWith("px") ? `${parseFloat(part_0) * scale}px` : part_0;
      $[13] = scale;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t2 = bgPosParts.map(t4).join(" ");
    $[6] = scale;
    $[7] = style.backgroundPosition;
    $[8] = style.backgroundSize;
    $[9] = scaledBgSize;
    $[10] = t2;
  } else {
    scaledBgSize = $[9];
    t2 = $[10];
  }
  const scaledBgPos = t2;
  const t3 = `${size}px`;
  const t4 = `${size}px`;
  const t5 = `url(https://wiki.play2xko.com/en-us/images/thumb/${championName}_cs.png/600px-${championName}_cs.png)`;
  let t6;
  if ($[15] !== scaledBgPos || $[16] !== scaledBgSize || $[17] !== t3 || $[18] !== t4 || $[19] !== t5) {
    t6 = <div style={{
      width: t3,
      height: t4,
      border: "1px solid rgba(255, 255, 255, 0.2)",
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      backgroundImage: t5,
      backgroundRepeat: "no-repeat",
      backgroundSize: scaledBgSize,
      backgroundPosition: scaledBgPos
    }} />;
    $[15] = scaledBgPos;
    $[16] = scaledBgSize;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};